import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

export default class extends Controller {
  static values = {
    url: String
  }

  connect() {
    this.initializeSortable()
  }

  disconnect() {
    if (this.sortable) {
      this.sortable.destroy()
    }
  }

  initializeSortable() {
    this.sortable = Sortable.create(this.element, {
      animation: 150,
      forceFallback: true,
      ghostClass: "sortable-ghost",
      chosenClass: "sortable-chosen",
      dragClass: "sortable-drag",
      fallbackClass: "sortable-fallback",
      handle: "[data-sortable-handle]",

      onMove: (evt) => this.validateMove(evt),
      onEnd: (evt) => this.handleDrop(evt)
    })
  }

  validateMove(evt) {
    const draggedPriority = evt.dragged.dataset.priority
    const relatedPriority = evt.related.dataset.priority

    return draggedPriority === relatedPriority
  }

  handleDrop(evt) {
    if (evt.oldIndex === evt.newIndex) return

    const taskId = evt.item.dataset.taskId
    const newPosition = evt.newIndex + 1

    this.updatePosition(taskId, newPosition)
  }

  updatePosition(taskId, newPosition) {
    const url = this.urlValue.replace("__TASK_ID__", taskId)

    fetch(url, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": this.csrfToken
      },
      body: JSON.stringify({ new_position: newPosition })
    }).catch((error) => {
      console.error("Reorder failed:", error)
    })
  }

  get csrfToken() {
    return document.querySelector('meta[name="csrf-token"]')?.content
  }
}
